import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Text, textToHTML } from '@siteground/styleguide';

import { sendUserToThirdPartyForReview } from '../../app-communication/actions/from-client-frontend';
import { ChatLayout } from '../../components/chat-layout';
import { ChatLogo } from '../../components/chat-logo';
import PresentationLayout from '../../components/presentation-layout/presentation-layout';
import { getChatHideRatingScreen, getFeedback } from '../../selectors/chat';
import { getIsAuthorized } from '../../selectors/chat-session';
import { ThankYouFooter } from './thank-you-footer';

const ThankYou = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [disableThirdPartyReviewButton, setDisableThirdPartyReviewButton] = React.useState(false);

  const hideRatingScreen = useSelector(getChatHideRatingScreen);
  const isAuthorized = useSelector(getIsAuthorized);
  const feedback = useSelector(getFeedback);

  const { rating, feedback_type } = feedback;

  let title = intl.formatMessage({ id: 'translate.thank.you.title.outstanding' });
  let message = intl.formatMessage({ id: 'translate.operator.feedback.message.generic' });
  let notice = intl.formatMessage({ id: 'translate.thank.you.submit.review.notice' });

  const shouldUserSubmitReview = !hideRatingScreen && isAuthorized && rating >= 4;

  if (shouldUserSubmitReview) {
    message = intl.formatMessage({ id: 'translate.thank.you.message.outstanding' });
  }

  if (feedback_type === 'trustpilot') {
    message = intl.formatMessage({ id: 'translate.thank.you.trustpilot.feedback.message' });
    notice = textToHTML(
      intl.formatMessage({ id: 'translate.thank.you.trustpilot.submit.review.notice' }),
      ['a'],
      ['href', 'target']
    );
  }

  return (
    <ChatLayout
      header={<ChatLogo />}
      content={
        <PresentationLayout
          title={title}
          titleLevel="2"
          message={message}
          icon={<Icon name="illustration-thumbs-up" width="138" height="97" multicolor />}
          alignLeft={shouldUserSubmitReview}
        >
          {shouldUserSubmitReview && (
            <React.Fragment>
              <div>
                <Button
                  color="primary"
                  disabled={disableThirdPartyReviewButton}
                  onClick={() => {
                    setDisableThirdPartyReviewButton(true);

                    dispatch(
                      sendUserToThirdPartyForReview({
                        payload: feedback,
                        onComplete: () => setDisableThirdPartyReviewButton(false),
                        onFailure: () => setDisableThirdPartyReviewButton(false)
                      })
                    );
                  }}
                >
                  {intl.formatMessage({ id: 'translate.thank.you.submit.review' })}
                </Button>
              </div>

              <Text size="small">{notice}</Text>
            </React.Fragment>
          )}
        </PresentationLayout>
      }
      contentPadding="none"
      footer={!isAuthorized && <ThankYouFooter />}
      footerPadding={['large', 'large', 'x-large', 'large']}
    />
  );
};

export default ThankYou;
